import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ScenarioAssessmentLinkComponent } from './scenario-assessment-link/scenario-assessment-link.component';
import { ScenarioAssessmentComponent } from './scenario-assessment/scenario-assessment.component';

const routes: Routes = [
    {
                        path:'',component:ScenarioAssessmentLinkComponent,
                        children:[
                          {
                            path:"ScenarioAssessment", component:ScenarioAssessmentComponent
                          },  
                        ]
                      }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ScenarioAssessmentRoutingModule { }
